import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import SideMenu from '../SideMenu';
import { isRTL } from '../../../helpers/formatLocale';
import { toggleAdminMenu } from '../../../actions/siteadmin/modalActions';
import s from './OffcanvasMenu.css';

function OffcanvasMenu({ show, locale, toggleAdminMenu, location }) {

    const handleMobileMenu = () => {
        toggleAdminMenu(false);
    }


    return (
        <div className={cx(s.customOffcanvasContainer, 'hidden-print')}>
            <div className={cx(s.customOffcanvasBackShadow, show && s.customOffcanvasBackShadowShow)} onClick={() => handleMobileMenu()} />
            <div className={cx(s.customOffcanvas, isRTL(locale) ? s.customOffcanvasEnd : s.customOffcanvasStart, show && s.customOffcanvasShow)}>
                <div className={s.customOffcanvasHeader} onClick={() => handleMobileMenu()}>
                    <button type="button" className={s.customOffcanvasBtnClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
                    </button>
                </div>
                <div className={s.customOffcanvasBody}>
                    <SideMenu handleMobileMenu={handleMobileMenu} location={location} />
                </div>
            </div>
        </div>
    )
}

const mapState = state => ({
    locale: state.intl.locale,
    show: state?.adminModalStatus?.isOpenAdminMenu,
});

const mapDispatch = {
    toggleAdminMenu
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(OffcanvasMenu)));
